import { Box, MenuButton as ChakraMenuButton, Flex, Stack, Text, useBreakpointValue } from '@chakra-ui/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import NotificationBadge from 'components/notification-badge'

import theme from 'theme'

import type { MenuButtonProps as ChakraMenuButtonProps } from '@chakra-ui/react'

type Props = {
  title: string
  subTitle?: string
  hasNotification?: boolean
} & ChakraMenuButtonProps

const MenuButton = ({ title, subTitle, hasNotification, ...menuButtonProps }: Props) => {
  const isLargeViewport = useBreakpointValue({ base: false, lg: true })

  return isLargeViewport ? (
    <ChakraMenuButton {...menuButtonProps}>
      <Flex h="100%" w="100%" align="center">
        <Flex h="100%" px="12px" align="center" justify="space-around">
          <Stack direction="column" align="flex-end" w="100%" px="16px" spacing={0} userSelect="none">
            <Text textStyle="body2" color={theme.baseColors.text.default}>
              {title}
            </Text>
            {subTitle && (
              <Text textStyle="body2" casing="uppercase" color={theme.baseColors.text.disabled}>
                {subTitle}
              </Text>
            )}
          </Stack>
          <Flex h="100%" px="12px">
            <FontAwesomeIcon icon={['far', 'chevron-down']} color="black" size="sm" />
            {hasNotification && (
              <Box mt="-8px">
                <NotificationBadge size="md" />
              </Box>
            )}
          </Flex>
        </Flex>
      </Flex>
    </ChakraMenuButton>
  ) : (
    <Box w="100%">
      {subTitle && (
        <Text textStyle="label" color={theme.colors.white}>
          {subTitle}
        </Text>
      )}
      <ChakraMenuButton w="100%">
        <Flex
          w="100%"
          px={3}
          py={2}
          borderRadius={theme.radii.base}
          border={theme.borders['1px']}
          borderColor={theme.colors.gray['300']}
          backgroundColor={theme.colors.white}
          justifyContent="space-between"
        >
          <Text textStyle="body2" color={theme.baseColors.text.default}>
            {title}
          </Text>
          <FontAwesomeIcon icon={['far', 'chevron-down']} color="black" size="sm" />
        </Flex>
      </ChakraMenuButton>
    </Box>
  )
}

export default MenuButton
